import { render, staticRenderFns } from "./AppReleasesTab.vue?vue&type=template&id=9c32407e&scoped=true"
import script from "./AppReleasesTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppReleasesTab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppReleasesTab.vue?vue&type=style&index=0&id=9c32407e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c32407e",
  null
  
)

export default component.exports